import styled from "styled-components";

export const ErrorBoundaryStyle = styled.div`
  width: 100%;
  background: #0B0F1B;
  min-height: 100vh;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  .error-container {
    max-width: 600px;
    width: 100%;
    background: linear-gradient(
      135deg,
      rgba(138, 43, 226, 0.1) 0%,
      rgba(255, 20, 147, 0.1) 100%
    );
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 40px;
    text-align: center;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);

    @media (max-width: 768px) {
      padding: 24px;
      margin: 20px;
    }
  }

  .error-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);

    svg {
      width: 40px;
      height: 40px;
      color: #ffffff;
    }

    @media (max-width: 768px) {
      width: 64px;
      height: 64px;

      svg {
        width: 32px;
        height: 32px;
      }
    }
  }

  .error-title {
    font-size: 28px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 16px;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    @media (max-width: 768px) {
      font-size: 24px;
    }
  }

  .error-message {
    font-size: 16px;
    color: #b8b8b8;
    margin-bottom: 24px;
    line-height: 1.6;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  .error-details {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 24px;
    text-align: left;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 12px;
    color: #ff6b6b;
    white-space: pre-wrap;
    overflow-x: auto;

    @media (max-width: 768px) {
      font-size: 11px;
      padding: 12px;
    }
  }

  .error-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
  }

  .error-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 24px;
    height: 44px;
    background: #007aff;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: -0.01em;
    text-align: center;
    border-radius: 22px;
    border: none;
    color: #fff;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 12px rgba(0, 122, 255, 0.3);

    &:hover {
      background: #0056cc;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 122, 255, 0.4);
    }

    &:active {
      transform: translateY(0px);
      box-shadow: 0 2px 8px rgba(0, 122, 255, 0.25);
    }

    &.secondary {
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.2);
      color: #ffffff;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.3);
      }
    }

    svg {
      margin-right: 8px;
      width: 16px;
      height: 16px;
    }

    @media (max-width: 768px) {
      padding: 10px 20px;
      height: 40px;
      font-size: 13px;

      svg {
        width: 14px;
        height: 14px;
        margin-right: 6px;
      }
    }
  }
`;
